/*!
 * Copyright Zendesk, Inc.
 * 
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0
 */
(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 24);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"l-backdrop":"index__l-backdrop___279bm","l-backdrop--center":"index__l-backdrop--center___2-MUj","is-rtl":"index__is-rtl___32n7v","is-visible":"index__is-visible___1e_WY","zd-backdrop-visible":"index__zd-backdrop-visible___aBbnX","c-dialog":"index__c-dialog___1lC89","c-dialog--large":"index__c-dialog--large___11FOx","is-open":"index__is-open___3ACOP","zd-dialog-open":"index__zd-dialog-open___37YDX","c-dialog__header":"index__c-dialog__header___3EPWd","c-dialog__close":"index__c-dialog__close___2Rw0L","is-focused":"index__is-focused___hsayV","is-hovered":"index__is-hovered___2csMj","is-active":"index__is-active___22Hmf","c-dialog__body":"index__c-dialog__body___1uEI9","c-dialog__footer":"index__c-dialog__footer___2W-JK"};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@zendeskgarden/react-theming");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("@zendeskgarden/react-selection");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTheming = __webpack_require__(1);

var _cssModals = __webpack_require__(0);

var _cssModals2 = _interopRequireDefault(_cssModals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'modals.header';

/**
 * Accepts all `<div>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var Header = _styledComponents2.default.div.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "4.0.1",
  className: _cssModals2.default['c-dialog__header']
}).withConfig({
  displayName: 'Header'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

/** @component */
exports.default = Header;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _cssModals = __webpack_require__(0);

var _cssModals2 = _interopRequireDefault(_cssModals);

var _reactSelection = __webpack_require__(4);

var _reactTheming = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * Copyright Zendesk, Inc.
                                                                                                                                                                                                                   *
                                                                                                                                                                                                                   * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                   * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                   */

var COMPONENT_ID = 'modals.close';

var StyledClose = _styledComponents2.default.button.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "4.0.1",
  className: function className(props) {
    var _classNames;

    return (0, _classnames2.default)(_cssModals2.default['c-dialog__close'], (_classNames = {}, _defineProperty(_classNames, _cssModals2.default['is-focused'], props.focused), _defineProperty(_classNames, _cssModals2.default['is-hovered'], props.hovered), _classNames));
  }
}).withConfig({
  displayName: 'Close__StyledClose'
})(['::-moz-focus-inner{border:0;}:focus{outline:none;}', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

/**
 * Used to close a Modal. Supports all `<button>` props.
 */

var Close = function (_Component) {
  _inherits(Close, _Component);

  function Close() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Close);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Close.__proto__ || Object.getPrototypeOf(Close)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFocused: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Close, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          other = _objectWithoutProperties(_props, ['onFocus', 'onBlur']); // eslint-disable-line react/prop-types


      var isFocused = this.state.isFocused;


      return _react2.default.createElement(StyledClose, _extends({
        focused: isFocused,
        onFocus: (0, _reactSelection.composeEventHandlers)(onFocus, function () {
          return _this2.setState({ isFocused: true });
        }),
        onBlur: (0, _reactSelection.composeEventHandlers)(onBlur, function () {
          return _this2.setState({ isFocused: false });
        })
      }, other));
    }
  }]);

  return Close;
}(_react.Component);

Close.propTypes = {
  focused: _propTypes2.default.bool,
  hovered: _propTypes2.default.bool
};
exports.default = Close;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTheming = __webpack_require__(1);

var _cssModals = __webpack_require__(0);

var _cssModals2 = _interopRequireDefault(_cssModals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'modals.body';

/**
 * Accepts all `<div>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var Body = _styledComponents2.default.div.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "4.0.1",
  className: _cssModals2.default['c-dialog__body']
}).withConfig({
  displayName: 'Body'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

/** @component */
exports.default = Body;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTheming = __webpack_require__(1);

var _cssModals = __webpack_require__(0);

var _cssModals2 = _interopRequireDefault(_cssModals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * Copyright Zendesk, Inc.
                                                                                                                                                                                                                   *
                                                                                                                                                                                                                   * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                   * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                   */

var COMPONENT_ID = 'modals.backdrop';

/**
 * Accepts all `<div>` props
 */
var Backdrop = _styledComponents2.default.div.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "4.0.1",
  className: function className(props) {
    var _classNames;

    return (0, _classnames2.default)(_cssModals2.default['l-backdrop'], (_classNames = {}, _defineProperty(_classNames, _cssModals2.default['l-backdrop--center'], props.center), _defineProperty(_classNames, _cssModals2.default['is-visible'], props.animate), _defineProperty(_classNames, _cssModals2.default['is-rtl'], (0, _reactTheming.isRtl)(props)), _classNames));
  }
}).withConfig({
  displayName: 'Backdrop'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

Backdrop.propTypes = {
  center: _propTypes2.default.bool,
  animate: _propTypes2.default.bool
};

/** @component */
exports.default = Backdrop;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTheming = __webpack_require__(1);

var _cssModals = __webpack_require__(0);

var _cssModals2 = _interopRequireDefault(_cssModals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * Copyright Zendesk, Inc.
                                                                                                                                                                                                                   *
                                                                                                                                                                                                                   * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                   * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                   */

var COMPONENT_ID = 'modals.modal_view';

/**
 * Accepts all `<div>` props
 */
var ModalView = _styledComponents2.default.div.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "4.0.1",
  className: function className(props) {
    var _classNames;

    return (0, _classnames2.default)(_cssModals2.default['c-dialog'], (_classNames = {}, _defineProperty(_classNames, _cssModals2.default['c-dialog--large'], props.large), _defineProperty(_classNames, _cssModals2.default['is-open'], props.animate), _defineProperty(_classNames, _cssModals2.default['is-rtl'], (0, _reactTheming.isRtl)(props)), _classNames));
  }
}).withConfig({
  displayName: 'ModalView'
})(['', ';'], function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

ModalView.propTypes = {
  large: _propTypes2.default.bool,
  animate: _propTypes2.default.bool
};

/** @component */
exports.default = ModalView;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelection = __webpack_require__(4);

var _FocusJailContainer = __webpack_require__(13);

var _FocusJailContainer2 = _interopRequireDefault(_FocusJailContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright Zendesk, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ModalContainer = function (_ControlledComponent) {
  _inherits(ModalContainer, _ControlledComponent);

  function ModalContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ModalContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalContainer.__proto__ || Object.getPrototypeOf(ModalContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      id: _reactSelection.IdManager.generateId()
    }, _this.getTitleId = function () {
      return _this.getControlledState().id + '--title';
    }, _this.getContentId = function () {
      return _this.getControlledState().id + '--content';
    }, _this.closeModal = function (event) {
      var onClose = _this.props.onClose;


      onClose && onClose(event);
    }, _this.getBackdropProps = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var onClick = _ref2.onClick,
          other = _objectWithoutProperties(_ref2, ['onClick']);

      return _extends({
        onClick: (0, _reactSelection.composeEventHandlers)(onClick, function (event) {
          _this.closeModal(event);
        })
      }, other);
    }, _this.getModalProps = function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref3$role = _ref3.role,
          role = _ref3$role === undefined ? 'dialog' : _ref3$role,
          onClick = _ref3.onClick,
          onKeyDown = _ref3.onKeyDown,
          other = _objectWithoutProperties(_ref3, ['role', 'onClick', 'onKeyDown']);

      return _extends({
        role: role,
        tabIndex: -1,
        'aria-modal': true,
        'aria-labelledby': _this.getTitleId(),
        'aria-describedby': _this.getContentId(),
        onClick: (0, _reactSelection.composeEventHandlers)(onClick, function (event) {
          /**
           * Don't want to trigger the backdrop close event
           * if click originates within the Modal
           */
          event.stopPropagation();
        }),
        onKeyDown: (0, _reactSelection.composeEventHandlers)(onKeyDown, function (event) {
          if (event.keyCode === _reactSelection.KEY_CODES.ESCAPE) {
            _this.closeModal(event);
          }
        })
      }, other);
    }, _this.getTitleProps = function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref4$id = _ref4.id,
          id = _ref4$id === undefined ? _this.getTitleId() : _ref4$id,
          other = _objectWithoutProperties(_ref4, ['id']);

      return _extends({
        id: id
      }, other);
    }, _this.getContentProps = function () {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref5$id = _ref5.id,
          id = _ref5$id === undefined ? _this.getContentId() : _ref5$id,
          other = _objectWithoutProperties(_ref5, ['id']);

      return _extends({
        id: id
      }, other);
    }, _this.getCloseProps = function () {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var onClick = _ref6.onClick,
          other = _objectWithoutProperties(_ref6, ['onClick']);

      return _extends({
        'aria-label': 'Close modal',
        onClick: (0, _reactSelection.composeEventHandlers)(onClick, function (event) {
          _this.closeModal(event);
        })
      }, other);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ModalContainer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          _props$render = _props.render,
          render = _props$render === undefined ? children : _props$render;


      return _react2.default.createElement(
        _FocusJailContainer2.default,
        null,
        function (_ref7) {
          var getContainerProps = _ref7.getContainerProps,
              containerRef = _ref7.containerRef;
          return render({
            getBackdropProps: _this2.getBackdropProps,
            getModalProps: function getModalProps(props) {
              return getContainerProps(_this2.getModalProps(props));
            },
            getTitleProps: _this2.getTitleProps,
            getContentProps: _this2.getContentProps,
            getCloseProps: _this2.getCloseProps,
            modalRef: containerRef,
            closeModal: _this2.closeModal
          });
        }
      );
    }
  }]);

  return ModalContainer;
}(_reactSelection.ControlledComponent);

ModalContainer.propTypes = {
  /**
   * @param {Object} renderProps
   * @param {Function} renderProps.getModalProps - Props to be spread onto the modal element
   * @param {Function} renderProps.getTitleProps - Props to be spread onto the modal title element
   * @param {Function} renderProps.getContentProps - Props to be spread onto the modal content element
   * @param {Function} renderProps.getCloseProps - Props to be spread onto the close button/icon
   * @param {Function} renderProps.modalRef - Callback for the ref of the containing modal
   * @param {Function} renderProps.closeModal - Callback to trigger the root `onClock` prop
   */
  children: _propTypes2.default.func,
  /**
   * Identical to children
   */
  render: _propTypes2.default.func,
  /**
   * The root ID to use for descendants. A unique ID is created if none is provided.
   **/
  id: _propTypes2.default.string,
  /**
   * Callback when a close action has been completed.
   * Can be triggered from the backdrop and close elements.
   * @param {Object} event - DOM event that triggered the close action
   */
  onClose: _propTypes2.default.func
};
exports.default = ModalContainer;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tabbable = __webpack_require__(23);

var _tabbable2 = _interopRequireDefault(_tabbable);

var _reactSelection = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright Zendesk, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var FocusJailContainer = function (_ControlledComponent) {
  _inherits(FocusJailContainer, _ControlledComponent);

  function FocusJailContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FocusJailContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FocusJailContainer.__proto__ || Object.getPrototypeOf(FocusJailContainer)).call.apply(_ref, [this].concat(args))), _this), _this.validateContainerRef = function () {
      if (!_this.container) {
        throw new Error('Accessibility Error: You must apply the ref prop to your containing element.');
      }
    }, _this.getContainerProps = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var onKeyDown = _ref2.onKeyDown,
          other = _objectWithoutProperties(_ref2, ['onKeyDown']);

      return _extends({
        onKeyDown: (0, _reactSelection.composeEventHandlers)(onKeyDown, function (event) {
          if (event.keyCode !== _reactSelection.KEY_CODES.TAB) {
            return;
          }

          _this.validateContainerRef();
          var elements = (0, _tabbable2.default)(_this.container);

          var index = elements.indexOf(event.target);

          if (elements.length === 0) {
            setTimeout(function () {
              _this.focusElement(_this.container);
            }, 0);

            event.stopPropagation();
            event.preventDefault();
          } else if (event.shiftKey) {
            var newIndex = index <= 0 ? elements.length - 1 : index - 1;

            setTimeout(function () {
              _this.focusElement(elements[newIndex]);
            }, 0);

            event.stopPropagation();
            event.preventDefault();
          } else {
            var _newIndex = (index + 1) % elements.length;

            setTimeout(function () {
              _this.focusElement(elements[_newIndex]);
            }, 0);

            event.stopPropagation();
            event.preventDefault();
          }
        })
      }, other);
    }, _this.containerRef = function (reference) {
      _this.container = reference;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FocusJailContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var focusOnMount = this.props.focusOnMount;


      this.validateContainerRef();

      if (focusOnMount) {
        this.focusElement(this.container);
      }
    }

    /** This method is added to the prototype of FocusJailContainer to allow for easier test mocking */
    /* eslint-disable class-methods-use-this */

  }, {
    key: 'focusElement',
    value: function focusElement(element) {
      element && element.focus();
    }
    /* eslint-enable class-methods-use-this */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          _props$render = _props.render,
          render = _props$render === undefined ? children : _props$render;


      return render({
        getContainerProps: this.getContainerProps,
        containerRef: this.containerRef
      });
    }
  }]);

  return FocusJailContainer;
}(_reactSelection.ControlledComponent);

FocusJailContainer.propTypes = {
  /**
   * @param {Object} renderProps
   * @param {Function} renderProps.getContainerProps - Props to be spread onto the element you want to jail
   * @param {Function} renderProps.containerRef - Callback for the ref of the containing element
   */
  children: _propTypes2.default.func,
  /**
   * Whether to focus the jailed container immediately on mount
   */
  focusOnMount: _propTypes2.default.bool,
  /**
   * Identical to children
   */
  render: _propTypes2.default.func
};
FocusJailContainer.defaultProps = {
  focusOnMount: true
};
exports.default = FocusJailContainer;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTheming = __webpack_require__(1);

var _cssModals = __webpack_require__(0);

var _cssModals2 = _interopRequireDefault(_cssModals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_ID = 'modals.footer';

/**
 * Accepts all `<div>` props
 */
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */

var Footer = _styledComponents2.default.div.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "4.0.1",
  className: _cssModals2.default['c-dialog__footer']
}).withConfig({
  displayName: 'Footer'
})(['&& > *{', ';}', ';'], function (props) {
  return (0, _reactTheming.isRtl)(props) ? 'margin-right: 8px' : 'margin-left: 8px';
}, function (props) {
  return (0, _reactTheming.retrieveTheme)(COMPONENT_ID, props);
});

/** @component */
exports.default = Footer;

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports = require("dom-helpers/util/scrollbarSize");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = require("dom-helpers/style");

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = require("dom-helpers/ownerWindow");

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = require("dom-helpers/ownerDocument");

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = require("dom-helpers/query/isWindow");

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = require("react-portal");

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPortal = __webpack_require__(21);

var _reactSelection = __webpack_require__(4);

var _isWindow = __webpack_require__(20);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(19);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _ownerWindow = __webpack_require__(18);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

var _style = __webpack_require__(17);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(16);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _ModalContainer = __webpack_require__(12);

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _ModalView = __webpack_require__(11);

var _ModalView2 = _interopRequireDefault(_ModalView);

var _Backdrop = __webpack_require__(10);

var _Backdrop2 = _interopRequireDefault(_Backdrop);

var _Body = __webpack_require__(9);

var _Body2 = _interopRequireDefault(_Body);

var _Close = __webpack_require__(8);

var _Close2 = _interopRequireDefault(_Close);

var _Header = __webpack_require__(7);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright Zendesk, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Use of this source code is governed under the Apache License, Version 2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * found at http://www.apache.org/licenses/LICENSE-2.0.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * High-level abstraction for basic Modal implementations. Accepts all `<div>` props.
 */
var Modal = function (_ControlledComponent) {
  _inherits(Modal, _ControlledComponent);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      id: _reactSelection.IdManager.generateId()
    }, _this.isOverflowing = function (element) {
      var doc = (0, _ownerDocument2.default)(element);
      var win = (0, _ownerWindow2.default)(doc);

      var isBody = element && element.tagName.toLowerCase() === 'body';

      /* istanbul ignore next */
      if (!(0, _isWindow2.default)(doc) && !isBody) {
        return element.scrollHeight > element.clientHeight;
      }

      var style = win.getComputedStyle(doc.body);
      var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
      var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);

      return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var bodyElement = document.querySelector('body');

      if (this.isOverflowing(bodyElement)) {
        var scrollbarSize = (0, _scrollbarSize2.default)();
        var bodyPaddingRight = parseInt((0, _style2.default)(bodyElement, 'paddingRight') || 0, 10);

        this.previousBodyPaddingRight = bodyElement.style.paddingRight;
        bodyElement.style.paddingRight = bodyPaddingRight + scrollbarSize + 'px';
      }

      this.previousBodyOverflow = bodyElement.style.overflow;
      bodyElement.style.overflow = 'hidden';
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var bodyElement = document.querySelector('body');

      bodyElement.style.overflow = this.previousBodyOverflow;
      bodyElement.style.paddingRight = this.previousBodyPaddingRight;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backdropProps = _props.backdropProps,
          children = _props.children,
          onClose = _props.onClose,
          center = _props.center,
          animate = _props.animate,
          modalProps = _objectWithoutProperties(_props, ['backdropProps', 'children', 'onClose', 'center', 'animate']);

      var _getControlledState = this.getControlledState(),
          id = _getControlledState.id;

      return _react2.default.createElement(
        _ModalContainer2.default,
        { onClose: onClose, id: id },
        function (_ref2) {
          var getBackdropProps = _ref2.getBackdropProps,
              getModalProps = _ref2.getModalProps,
              getTitleProps = _ref2.getTitleProps,
              getContentProps = _ref2.getContentProps,
              getCloseProps = _ref2.getCloseProps,
              modalRef = _ref2.modalRef;
          return _react2.default.createElement(
            _reactPortal.Portal,
            null,
            _react2.default.createElement(
              _Backdrop2.default,
              getBackdropProps(_extends({ center: center, animate: animate }, backdropProps)),
              _react2.default.createElement(
                _ModalView2.default,
                _extends({}, getModalProps(_extends({ animate: animate }, modalProps)), { innerRef: modalRef }),
                _react.Children.map(children, function (child) {
                  if (child.type === _Header2.default) {
                    return (0, _react.cloneElement)(child, getTitleProps(child.props));
                  }

                  if (child.type === _Body2.default) {
                    return (0, _react.cloneElement)(child, getContentProps(child.props));
                  }

                  if (child.type === _Close2.default) {
                    return (0, _react.cloneElement)(child, getCloseProps(child.props));
                  }

                  return child;
                })
              )
            )
          );
        }
      );
    }
  }]);

  return Modal;
}(_reactSelection.ControlledComponent);

Modal.propTypes = {
  children: _propTypes2.default.any,
  /**
   * Props to spread onto backdrop element
   */
  backdropProps: _propTypes2.default.object,
  /**
   * Enable large modal styling
   */
  large: _propTypes2.default.bool,
  /**
   * Enable modal animation
   */
  animate: _propTypes2.default.bool,
  /**
   * Center modal
   */
  center: _propTypes2.default.bool,
  /**
   * Callback when a close action has been completed.
   * Can be triggered from the backdrop and Close icon.
   * @param {Object} event - DOM event that triggered the close action
   */
  onClose: _propTypes2.default.func,
  /**
   * The root ID to use for descendants. A unique ID is created if none is provided.
   **/
  id: _propTypes2.default.string
};
Modal.defaultProps = {
  animate: true,
  center: true
};
exports.default = Modal;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = require("tabbable");

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FocusJailContainer = __webpack_require__(13);

Object.defineProperty(exports, 'FocusJailContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FocusJailContainer).default;
  }
});

var _ModalContainer = __webpack_require__(12);

Object.defineProperty(exports, 'ModalContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModalContainer).default;
  }
});

var _Modal = __webpack_require__(22);

Object.defineProperty(exports, 'Modal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Modal).default;
  }
});

var _Backdrop = __webpack_require__(10);

Object.defineProperty(exports, 'Backdrop', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Backdrop).default;
  }
});

var _Body = __webpack_require__(9);

Object.defineProperty(exports, 'Body', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Body).default;
  }
});

var _Close = __webpack_require__(8);

Object.defineProperty(exports, 'Close', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Close).default;
  }
});

var _Footer = __webpack_require__(14);

Object.defineProperty(exports, 'Footer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Footer).default;
  }
});

var _Header = __webpack_require__(7);

Object.defineProperty(exports, 'Header', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Header).default;
  }
});

var _ModalView = __webpack_require__(11);

Object.defineProperty(exports, 'ModalView', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModalView).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })
/******/ ])));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zendeskgarden/react-modals/dist/index.js
// module id = 1670
// module chunks = 7